module.exports = __webpack_public_path__ + "img/hash.d7bae881.svg";